"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { motion } from "framer-motion";
import Avatar from "@/app/assets/Avatar.webp";
import { ThemeToggle } from "./theme-toggle";

type ToolbarItem = {
  name: string;
  href: string;
  paths: string[];
};

const toolbarItems: ToolbarItem[] = [
  { name: "Home", href: "/", paths: ["/"] },
  { name: "Craft", href: "/craft", paths: ["/craft"] },
  { name: "Projects", href: "/projects", paths: ["/projects"] },
];

export function FloatingNav() {
  const pathname = usePathname();

  return (
    <div className="fixed bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 z-[100000] text-xs sm:text-sm select-none max-w-[calc(100vw-2rem)]">
      <div className="rounded-full bg-white dark:bg-black pl-2 sm:pl-4 pr-2 sm:pr-4 h-10 sm:h-11 flex items-center drop-shadow-lg border border-[var(--gray-5)] w-fit">
        <div className="h-10 sm:h-11 overflow-hidden w-9 sm:w-11 shrink-0">
          <Image
            height={36}
            width={36}
            className="translate-y-[4px] pt-2 mr-2 pr-2"
            alt="Matteo LEDEE"
            src={Avatar}
          />
        </div>
        {toolbarItems.map((item) => {
          const isActive = item.paths.find((path) =>
            path === "/" ? pathname === path : pathname.startsWith(path)
          );

          return (
            <Link
              key={item.name}
              href={item.href}
              className={`relative transition-colors hover:transition-none duration-150 ease-out px-1.5 sm:px-2 py-3 sm:py-3.5 font-medium ${
                isActive
                  ? "text-[var(--gray-12)]"
                  : "text-[var(--gray-9)] hover:text-[var(--gray-12)]"
              }`}
            >
              {isActive && (
                <motion.div
                  layoutId="nav-dot"
                  layout="position"
                  className="rounded-full bg-[var(--blue-9)] shadow-sm"
                  style={{
                    position: "absolute",
                    bottom: 8,
                    left: "50%",
                    marginLeft: -3,
                    width: 6,
                    height: 6,
                  }}
                />
              )}
              <span>{item.name}</span>
            </Link>
          );
        })}
        <ThemeToggle />
      </div>
    </div>
  );
}
